module.exports = __webpack_public_path__ + "static/media/DSCF6306.7a349edb.jpg";